/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserTotpCodePurposes } from './user-totp-code-purposes';


export interface SendUserCodeToEmailRequest { 
    purpose: UserTotpCodePurposes;
}



